/**
 * Sélecteur de langue (FR / EN).
 */

import { useTranslation } from "react-i18next";

import { cn } from "../lib/cn";

export function LanguageSwitcher({ className }: { className?: string }) {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage ?? "fr";

  return (
    <div className={cn("inline-flex items-center gap-1 rounded-lg border border-slate-200 bg-white p-1 text-xs", className)}>
      {(["fr", "en"] as const).map((lng) => (
        <button
          key={lng}
          type="button"
          onClick={() => void i18n.changeLanguage(lng)}
          className={cn(
            "rounded px-2 py-1 font-medium uppercase transition",
            current === lng ? "bg-brand-600 text-white" : "text-slate-600 hover:bg-slate-100",
          )}
        >
          {lng}
        </button>
      ))}
    </div>
  );
}
